import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useScheduleDay, useAssignWorker } from '@/hooks/data/useSchedule'
import { useWorkers } from '@/hooks/data/useWorkers'

function statusColor(s: string) {
  return { Unassigned: 'bg-gray-100 text-gray-700', Assigned: 'bg-blue-100 text-blue-700', InProgress: 'bg-amber-100 text-amber-700', Completed: 'bg-green-100 text-green-700', Cancelled: 'bg-red-100 text-red-700' }[s] ?? 'bg-gray-100'
}

function SchedulePage() {
  const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10))
  const day = useScheduleDay(date)
  const workers = useWorkers()
  const assign = useAssignWorker(date)

  return (
    <div className="p-6">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-xl font-semibold text-gray-900">Dispatch Board</h1>
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="rounded border border-gray-300 px-3 py-1.5 text-sm" />
      </div>
      {day.isLoading && <p className="text-sm text-gray-500">Loading schedule…</p>}
      {day.isError && <p className="text-sm text-red-600">Failed to load — requires the manager role.</p>}
      <div className="space-y-2">
        {day.data?.jobs.map((j) => (
          <div key={j.jobId} className="flex items-center justify-between rounded-lg border border-gray-100 bg-white p-4 shadow-sm">
            <div>
              <p className="font-medium text-gray-900">{j.serviceType} · {j.suburb}</p>
              <p className="text-xs text-gray-500">{new Date(j.scheduledStart).toLocaleTimeString('en-NZ', { hour: '2-digit', minute: '2-digit' })} → {new Date(j.scheduledEnd).toLocaleTimeString('en-NZ', { hour: '2-digit', minute: '2-digit' })}</p>
            </div>
            <div className="flex items-center gap-3">
              <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${statusColor(j.status)}`}>{j.status}</span>
              {j.status === 'Unassigned' && (
                <select defaultValue="" onChange={(e) => e.target.value && assign.mutate({ jobId: j.jobId, workerId: e.target.value })} className="rounded border border-gray-300 px-2 py-1 text-sm">
                  <option value="" disabled>Assign…</option>
                  {workers.data?.map((w) => <option key={w.id} value={w.id}>{w.name}</option>)}
                </select>
              )}
            </div>
          </div>
        ))}
        {day.data && day.data.jobs.length === 0 && <p className="text-sm text-gray-500">No jobs scheduled for {date}.</p>}
      </div>
    </div>
  )
}

export const Route = createFileRoute('/(admin)/schedule/')({ component: SchedulePage })
